import React from 'react';
import { Link } from 'react-router-dom';

import { FormattedMessage } from '../../util/reactIntl';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';
import { createResourceLocatorString } from '../../util/routes';
import { inventoryBackPath, neighbourVehicles } from '../../util/inventoryNavigation';

import css from './InventoryListingNavigation.module.css';

/**
 * Back to the results this vehicle was opened from, and previous and next vehicles within them.
 * Without saved results, Back goes to the inventory and no vehicle links are shown.
 */
const InventoryListingNavigation = props => {
  const { listingId, className } = props;
  const routeConfiguration = useRouteConfiguration();

  const backPath = inventoryBackPath();
  const neighbours = neighbourVehicles(listingId);
  const vehiclePath = item =>
    createResourceLocatorString('ListingPage', routeConfiguration, {
      id: item.id,
      slug: item.slug,
    });

  return (
    <nav className={className ? `${css.root} ${className}` : css.root}>
      <Link className={css.back} to={backPath}>
        <FormattedMessage id="InventoryListingNavigation.backToResults" />
      </Link>
      {neighbours ? (
        <div className={css.step}>
          {neighbours.prev ? (
            <Link className={css.stepLink} to={vehiclePath(neighbours.prev)} rel="prev">
              <FormattedMessage id="InventoryListingNavigation.previous" />
            </Link>
          ) : (
            <span className={css.stepDisabled} aria-hidden="true" />
          )}
          <span className={css.position}>
            <FormattedMessage
              id="InventoryListingNavigation.position"
              values={{ position: neighbours.position, total: neighbours.total }}
            />
          </span>
          {neighbours.next ? (
            <Link className={css.stepLink} to={vehiclePath(neighbours.next)} rel="next">
              <FormattedMessage id="InventoryListingNavigation.next" />
            </Link>
          ) : (
            <span className={css.stepDisabled} aria-hidden="true" />
          )}
        </div>
      ) : null}
    </nav>
  );
};

export default InventoryListingNavigation;
